import { useEffect, useMemo, useState } from "react";
import { Icon } from "./Icon";

const COMANDOS = [
  { label: "Pendientes", hint: "cola de decisión", to: "/pendientes" },
  { label: "Histórico", hint: "decisiones pasadas", to: "/historico" },
  { label: "Métricas", hint: "volumen y precisión", to: "/metricas" },
  { label: "Configuración", hint: "modo y umbral", to: "/configuracion" },
  { label: "Usuarios", hint: "accesos al portal", to: "/usuarios" },
];

export default function CommandPalette({
  onClose, onGo,
}: { onClose: () => void; onGo: (to: string) => void }) {
  const [q, setQ] = useState("");
  const [i, setI] = useState(0);

  const items = useMemo(() => {
    const t = q.trim().toLowerCase();
    return t
      ? COMANDOS.filter((c) => (c.label + c.hint).toLowerCase().includes(t))
      : COMANDOS;
  }, [q]);

  useEffect(() => setI(0), [q]);

  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === "ArrowDown") { e.preventDefault(); setI((v) => Math.min(v + 1, items.length - 1)); }
      if (e.key === "ArrowUp") { e.preventDefault(); setI((v) => Math.max(v - 1, 0)); }
      if (e.key === "Enter" && items[i]) onGo(items[i].to);
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [items, i, onGo]);

  return (
    <div className="overlay" onClick={onClose}>
      <div className="palette" onClick={(e) => e.stopPropagation()}>
        <input
          autoFocus
          placeholder="Ir a..."
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
        {items.length === 0 && <div className="palette-item">Sin resultados</div>}
        {items.map((c, n) => (
          <div
            key={c.to}
            className={"palette-item" + (n === i ? " on" : "")}
            onMouseEnter={() => setI(n)}
            onClick={() => onGo(c.to)}
          >
            <Icon name="search" />
            <span style={{ fontWeight: 550 }}>{c.label}</span>
            <span style={{ color: "var(--faint)", fontSize: 12 }}>{c.hint}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
